module.exports = __webpack_public_path__ + "static/media/iconmonstr-twitter-4.4b6f1279.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/iconmonstr-twitter-4.svg
// module id = 240
// module chunks = 0